<template>
    <!--切换门店-->
    <PopForm v-if="showState" width="380px" body-max-height="430px" :show-foot="false">
        <template v-slot:title>
            <div class="title">
                门店切换
                <i class="el-icon-close close" @click="close" />
            </div>
        </template>
        <div class="store-list">
            <div class="searchForm">
                <el-input placeholder="请输入门店名称" v-model="searchValue" @keypress.native="e => {if(e.charCode === 13) loadStoreList();}">
                    <el-button slot="append" type="primary" icon="el-icon-search" @click="loadStoreList">搜索</el-button>
                </el-input>
            </div>
            <ul class="searchData flex-1" ref="searchData">
                <li class="pro" v-for="item in searchData" :key="item.id"  @click="switchStore(item)">
                    <span class="pro-title">{{item.store_name}} <el-tag size="mini" type="warning" v-if="item.is_main === '1'">&nbsp;总店&nbsp;</el-tag></span>

                </li>
            </ul>
        </div>
    </PopForm>
</template>

<script>
    import obj from "@/js/obj";
    import PopForm from "@/model/PopForm";
    export default {
        name: "ChainSwitchStore",
        components: {PopForm},
        model:{
            prop: "state",
            event: "stateChange"
        },
        props: {
            state: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                showState: false,
                searchValue: "",
                searchData: [],
            };
        },
        methods: {
            init(){
                this.loadStoreList();
            },
            //关闭
            close(){
                this.$emit("stateChange", false);
            },
            //切换门店
            switchStore(store){
                this.$store.dispatch("setSession", {store_id: store.id});
                this.close();
                this.$root.go("/");
            },
            //获取门店列表
            loadStoreList(){
                this.$root.postData("chain/get_switch_store_list", {keyword: this.searchValue}, res => {
                    if(res.errcode === 0) {
                        this.searchData = res.data;
                        this.showState = true;
                    }else{
                        this.close();
                        if(res.errcode !== 104 && res.errcode !== 105) this.$root.error(res.errdesc);
                    }
                });
            }
        },
        watch: {
            state(val){
                if(val) this.init();
                else this.showState = false;
            },
            "searchData"() {
                this.$nextTick(function () {
                    obj.unScrollbar(this.$refs["searchData"]);
                    obj.scrollbar(this.$refs["searchData"]);
                });
            },
        }
    }
</script>

<style scoped>
    .close{
        float: right;
        line-height: 24px;
    }
    .store-list{
        padding-top: 6px;
    }
    .searchForm{
        padding-left: 16px;
        padding-right: 16px;
        height: 40px;
        padding-bottom: 16px;
    }
    .searchData{
        overflow: hidden;
        width: 100%;
        min-height: 300px;
    }
    .searchData li{
        display: block;
        padding: 5px 20px;
        line-height: 22px;
        position: relative;
    }
    .searchData li.pro:hover{
        background: #F5F7FA;
        cursor: pointer;
    }
    .searchData li>span.pro-title{
        display: inline-block;
        width: 270px;
        vertical-align: text-top;
    }
</style>
